module.exports = __webpack_public_path__ + "static/dp-logo-small-white-858e36c5ddd4f6dcf5edc2dd0d7abe7c.svg";